import PropTypes from 'prop-types';
import React from 'react';

import { userArrayProptypes } from '../../../propTypes';
import { avatarWithFallbackWhenMissing } from '../../../utils/avatarUtils';
import EntityLink from '../../EntityLink';
import ItemGridBlock from '../../cms/ItemGridBlock';
import { getAvatarTitle } from './SimpleVariant';

const DetailsVariant = (props) => {
  const { users, gridProps, ...rest } = props;
  const { imageKey, size, imageSize, showModal, defaultThumbnail, template } = rest;
  const items = users.map((user) => ({
    ...user,
    title: getAvatarTitle(user, template),
    fullDescription: user.description,
    description: `${user.role || ''}`,
    subDescription: `${user.company || ''}`,
    image: avatarWithFallbackWhenMissing(user[imageKey], size, defaultThumbnail),
  }));

  return (
    <div>
      <ItemGridBlock
        item={{ imageSize }}
        container={{ type: 'headerless' }}
        grid={{ doubling: true, ...gridProps }}
        items={items}
        as={showModal ? EntityLink : undefined}
      />
    </div>
  );
};

DetailsVariant.propTypes = {
  gridProps: PropTypes.object,
  users: userArrayProptypes,
};
DetailsVariant.defaultProps = {
  gridProps: undefined,
  users: [],
};

export default DetailsVariant;
